import React from "react";
import { Box, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import {
  FaClipboardCheck,
  FaBook,
  FaClock,
  FaCalendarAlt,
  FaArrowLeft,
} from "react-icons/fa";
/* ========================= EXAM CARD ========================= */
function ExamCard({ exam }) {
  return (
    <Box className="assessment-card exam-card">
      {" "}
      {/* Visual */}{" "}
      <div className="assessment-visual exam-visual">
        {" "}
        <div className="assessment-top">
          {" "}
          <span className="assessment-brand"> PureEng </span>{" "}
          <span className="assessment-type"> EXAM </span>{" "}
        </div>{" "}
        <div className="assessment-icon">
          {" "}
          <FaClipboardCheck />{" "}
        </div>{" "}
        <div className="assessment-visual-title">
          {" "}
          <strong>TEST YOUR SKILLS</strong> <span>English Assessment</span>{" "}
        </div>{" "}
      </div>{" "}
      {/* Content */}{" "}
      <CardContent className="assessment-content">
        {" "}
        <span className="assessment-badge exam-badge">
          {" "}
          اختبار إلكتروني{" "}
        </span>{" "}
        <h3 className="assessment-title"> {exam.title} </h3>{" "}
        <p className="assessment-description">
          {" "}
          {exam.description ||
            "اختبر مستواك وشوف قدرتك على تطبيق اللي اتعلمته."}{" "}
        </p>{" "}
        {/* Details */}{" "}
        <div className="assessment-details">
          {" "}
          <div className="assessment-detail">
            {" "}
            <div className="detail-icon">
              {" "}
              <FaCalendarAlt />{" "}
            </div>{" "}
            <div>
              {" "}
              <span>يفتح في</span>{" "}
              <strong>
                {" "}
                {exam.opensAtUtc
                  ? new Date(exam.opensAtUtc).toLocaleDateString("ar-EG")
                  : "غير محدد"}{" "}
              </strong>{" "}
            </div>{" "}
          </div>{" "}
          <div className="assessment-detail">
            {" "}
            <div className="detail-icon">
              {" "}
              <FaClock />{" "}
            </div>{" "}
            <div>
              {" "}
              <span>المدة</span>{" "}
              <strong>
                {" "}
                {exam.durationMinutes
                  ? `${exam.durationMinutes} دقيقة`
                  : "غير محددة"}{" "}
              </strong>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
        <Link
          className="assessment-button exam-button"
          to={`/exams/${exam.id}/start`}
        >
          {" "}
          <span>ابدأ الامتحان</span> <FaArrowLeft />{" "}
        </Link>{" "}
      </CardContent>{" "}
    </Box>
  );
};
export default ExamCard;